import React, { useState } from 'react';
import RecipeSidebar, { RecipeSidebarRef } from '../Recipe/RecipeSidebar';

interface KitchenLayoutProps {
  children: React.ReactNode;
  title: string;
  selectedRecipe?: string;
  sidebarRef?: React.Ref<RecipeSidebarRef>;
  className?: string;
}

const KitchenLayout: React.FC<KitchenLayoutProps> = ({
  children,
  title,
  selectedRecipe,
  sidebarRef,
  className = 'bg-gray-50',
}) => {
  const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);

  return (
    <div className={`flex h-full min-h-0 w-full flex-col overflow-hidden ${className}`}>
      <header className="flex h-[calc(3.5rem+env(safe-area-inset-top))] shrink-0 items-center gap-3 border-b border-gray-200 bg-white px-3 pt-[env(safe-area-inset-top)] lg:hidden">
        <button
          type="button"
          onClick={() => setMobileNavigationOpen(true)}
          className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          aria-label="Open Kitchen navigation"
          aria-expanded={mobileNavigationOpen}
        >
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
          </svg>
        </button>
        <div className="min-w-0 flex-1">
          <div className="text-xs font-semibold uppercase tracking-wide text-gray-400">Kitchen</div>
          <div className="truncate text-sm font-semibold text-gray-950">{title}</div>
        </div>
      </header>

      <div className="flex min-h-0 flex-1 overflow-hidden">
        <RecipeSidebar
          ref={sidebarRef}
          selectedRecipe={selectedRecipe}
          mobileOpen={mobileNavigationOpen}
          onMobileClose={() => setMobileNavigationOpen(false)}
        />
        {children}
      </div>
    </div>
  );
};

export default KitchenLayout;
